module.exports = __webpack_public_path__ + "img/train-stop-bottom.edadc4b9.png";